
var globalFilterTypes = ['style','cut'];
jQuery(document).ready(function($) {
    
    $('.js-archive-pagination').on('click', 'a[data-page]', function(e) {
        e.preventDefault(); 
        const obj = jQuery(this);
        const cpt = obj.closest('.section-archive-wrapper').attr('data-cpt');
        const pagenum = obj.attr('data-page');
        const filters = retrieveExistingFilter();
        loadArchive(pagenum,filters,cpt);
    });

    $(document).on('click', '.archive-filter-item[data-taxonomy]', function(e){
        const obj = jQuery(this);
        if(obj.hasClass('default')){ // All
            obj.addClass('active');
            obj.siblings().removeClass('active');
        }else{ // The rest
            obj.toggleClass('active');
            if(obj.siblings().addBack().filter('.active').length < 1){ 
                obj.siblings('.archive-filter-item.default').addClass('active');
            }else{
                if(obj.attr('data-taxonomy') == 'style'){ //style
                    obj.siblings('.archive-filter-item.default').removeClass('active');
                }else{ //cut
                    obj.siblings().removeClass('active');
                }
            }
        }
        setTimeout(function(){
            archiveShowActionButtons();
        },500)
    })

    
    // APPLY FILTER /////////////////////////////////////////////////
    $(document).on('click','.archive-filter-action-apply',function(){
        let arr = [];
        const cpt = jQuery(this).closest('.section-archive-wrapper').attr('data-cpt');
        localFilterTypes = jQuery(this).attr('data-filtyp').split(',');
        jQuery.each(localFilterTypes, function(key, type) {
            arr[type] = [];
            jQuery('.archive-filter-item.active[data-taxonomy="'+type+'"]').each(function(index, element) {
                const termId = jQuery(this).attr('data-termid');
                arr[type].push(termId);
            });
            updateArchiveParams(type,arr[type].join(','));
        })
        loadArchive(1,arr,cpt);
    })
    
});

